import React, {useState, useEffect} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import {changeLibraryModal, clearLibraryActiveFile, requestFileAccess, resetFileAccess} from '../../../../../redux/actions/library'
import { sendErrorNotification } from '../../../../universal/notifications/notifications'
import { TransparentButton, SolidButton } from '../../../../library/button'
import { Input } from '../../../../library/input'
import { Popup } from '../../../../library/popup'
import './style.scss'

const Index = () => {

    const dispatch = useDispatch()
    const modalState = useSelector(state => state.library.showModals.unlockModal)
    const loading = useSelector(state => state.library.unlockFile.loading)
    const error = useSelector(state => state.library.unlockFile.error)
    const activeId = useSelector(state => state.library.activeId)
    const unlockUrl = useSelector(state => state.library.unlockFile.destination)
    const companyId = useSelector(state => state.activeCompany.activeCompany.id)

    const [unlockPassword, setUnlockPassword] = useState("")

    useEffect(() => {
        if(error){
            sendErrorNotification(error)
            setUnlockPassword("")
        }
    }, [error])

    const handleClose = () => {
        dispatch(changeLibraryModal({unlockModal: false}))
        dispatch(clearLibraryActiveFile(null))
        dispatch(resetFileAccess(null))
    }

    const clickLockedLink = () => {
        dispatch(changeLibraryModal({unlockModal: false}))
        dispatch(resetFileAccess(null))
    }

    const clickUnlockLibraryFile = e => {
        dispatch(requestFileAccess({password: unlockPassword, key: activeId, companyId: companyId}))
    }

    const renderCancelButton = () => {
        if(!unlockUrl){
            return <TransparentButton title="Avbryt" type="button" data-dismiss="modal" onClick={() => handleClose()} />
        }
        return null
    }

    const renderUnlockButton = () => {
        if(!unlockUrl){
            return <SolidButton color="blue" title={loading ? "Låser opp..":"Lås opp"} icon={loading ? <i className="fas fa-circle-notch fa-spin"></i>:<i className="fas fa-key"></i>} onClick={() => clickUnlockLibraryFile()} type="button"/>
        }
        return null
    }

    return(
        <Popup
            onClose={handleClose}
			show={modalState} 
			title="Filen er passordbeskyttet"
			buttons={[
				renderCancelButton(),
				renderUnlockButton()
			]}
        >
            <div className="unlock-file-content-container">
                {unlockUrl && !loading ?
                    <div className="inner-unlocked-container">
                        <h1 className="unlock-icon"><i className="fas fa-link"></i></h1>
                        <h1 className="unlock-title">Dette er linken til filen din</h1>
                        <a target="_blank" rel="noopener noreferrer" onClick={clickLockedLink} className="unlock-link" href={unlockUrl}>{unlockUrl.substr(0.,90)}..</a>
                    </div>
                :
                    <div className="inner-unlock-container">
                        <h1 className="unlock-icon"><i className="fas fa-lock"></i></h1>
                        <h1 className="unlock-title">Denne filen er passordbeskyttet</h1>
                        <p className="unlock-description">Vennligst tast inn passord for å åpne denne filen.</p>
                        <form onSubmit={clickUnlockLibraryFile}>
                            <Input onChange={(e) => setUnlockPassword(e.target.value)} value={unlockPassword} placeholder="Passord" type="password"/>
                        </form>
                    </div>
                }
            </div>
            <ToastContainer/>
        </Popup>
    )
}

export default Index
